export default "__VITE_ASSET__ed2d750c__"